import React, { useEffect, useMemo } from 'react';
import { MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { Field, useFormikContext } from 'formik';
import { Select } from 'formik-material-ui';

import { getValueByPropPath } from 'Utils/objectHelpers';

export const SelectRvLot = ({ rvLots, name, inputId, disabled }) => {
  const { values, setFieldValue } = useFormikContext();
  const value = getValueByPropPath(values, name);
  const { rvs, hasRvs } = values;

  const options = useMemo(
    () =>
      rvLots.map(({ id, nameWithFlip, disabled }) => {
        return (
          <MenuItem key={id} value={id} disabled={disabled}>
            {nameWithFlip}
          </MenuItem>
        );
      }),
    [JSON.stringify(rvLots), name, JSON.stringify(rvs)]
  );

  useEffect(() => {
    const rv = getValueByPropPath(values, `rvs[${inputId}]`, {});
    if (value) {
      const rvLot = rvLots.find(lot => rv.rvLotId && lot.id === rv.rvLotId);
      if (rvLot && rv.rvLotId !== rv?.rvLot?.id) {
        setFieldValue(`rvs[${inputId}]`, { ...rv, rvLot: { ...rvLot }, spots: [], rvSpots: [] });
      }
    } else {
      setFieldValue(`rvs[${inputId}]`, { ...rv, rvLot: undefined });
    }
  }, [value]);

  return (
    <div className={'select-field'}>
      <FormControl>
        <InputLabel htmlFor={name}>&nbsp;</InputLabel>
        <Field
          as="select"
          name={name}
          render={({ meta = {}, ...props }) => (
            <Select
              {...props}
              meta={meta}
              error={meta.touched && meta.error ? meta.error : null}
              disabled={!hasRvs || disabled}
              helperText={meta.touched && meta.error ? meta.error : null}>
              {options}
            </Select>
          )}
        />
      </FormControl>
    </div>
  );
};
